import jsPDF from "jspdf"
import 'jspdf-autotable'
import cabecalho from "@/relatorios/geral/header";

export default {

    run(item){

        let header = []
        header.push(cabecalho.run())

        let relatorio = []

        relatorio.push([{ content: item.descricao, colSpan: 4, styles: { halign: 'center' }}])

        relatorio.push(
            [
                { content: item.titulos[0], styles: { halign: 'center' }},
                { content: item.titulos[1], styles: { halign: 'center' }},
                { content: item.titulos[2], styles: { halign: 'center' }},
                { content: item.titulos[3], styles: { halign: 'center' }},
            ])

        if(item.recursos.length > 0){

            let obs = ''

            for(let i = 0; i < item.recursos.length; i++){

                obs = item.recursos[i]['obs']
                obs = (obs == null ? '' : obs)

                relatorio.push(
                    [
                        { content: item.recursos[i]['inscricao'], styles: { halign: 'center' }},
                        { content: item.recursos[i]['nome'], styles: { halign: 'center' }},
                        { content: item.recursos[i]['situacao'], styles: { halign: 'center' }},
                        { content: obs, styles: { halign: 'center', valign: 'middle' }},
                    ])
            }
        }

        const doc = new jsPDF()

        //Tabela do cabeçalho
        doc.autoTable({theme: 'plain', body: header, didDrawCell: (data) => {
                if (data.section === 'body' && data.column.index === 0) {
                    var base64Img = cabecalho.logo()
                    doc.addImage(base64Img, 'JPEG', data.cell.x + 3, data.cell.y, 30, 20)
                }
            },})

        doc.autoTable({theme: 'grid', body: relatorio})

        doc.output('dataurlnewwindow')
    },
}
